import React from 'react'
import { FrequentlyAccessedHeading, TileRow, Tile, TileLogo, TileLabel } from './styled'
import LogoProcore from 'url:./assets/logo-procore.png'
import LogoDocebo from 'url:./assets/logo-docebo.png'
import LogoHelpDesk from 'url:./assets/logo-helpdesk.svg'
import LogoEmburse from 'url:./assets/logo-emburse.png'
import LogoAdp from 'url:./assets/logo-adp.png'
import LogoBuildr from 'url:./assets/logo-buildr.png'
import LogoOpenSpace from 'url:./assets/logo-openspace.png'
import LogoTeams from 'url:./assets/logo-teams.png'

// TODO(NIBBI-113): '#' hrefs are placeholders until the real URLs are confirmed
const links = [
	{ label: 'Procore', href: '#', logo: LogoProcore, width: 36, height: 36 },
	{ label: 'Docebo', href: 'https://nibbi.docebosaas.com/', logo: LogoDocebo, width: 36, height: 36 },
	{ label: 'Help Desk', href: 'https://ithelp.nibbi.com', logo: LogoHelpDesk, width: 37, height: 37 },
	{ label: 'Emburse', href: '#', logo: LogoEmburse, width: 36, height: 36 },
	{ label: 'ADP', href: '#', logo: LogoAdp, width: 49, height: 28 },
	{ label: 'Builder', href: '#', logo: LogoBuildr, width: 36, height: 36 },
	{ label: 'OpenSpace', href: '#', logo: LogoOpenSpace, width: 38, height: 38 },
	{ label: 'SharePoint\nTeams', href: '#', logo: LogoTeams, width: 36, height: 36 }
]

function FrequentlyAccessed() {
	return (
		<>
			<FrequentlyAccessedHeading>Frequently Accessed Links</FrequentlyAccessedHeading>
			<TileRow>
				{links.map((link) => {
					const external = link.href !== '#'
					return (
						<Tile
							key={link.label}
							href={link.href}
							target={external ? '_blank' : undefined}
							rel={external ? 'noopener noreferrer' : undefined}
						>
							<TileLogo>
								<img src={link.logo} alt="" width={link.width} height={link.height} />
							</TileLogo>
							<TileLabel $twoLines={link.label.includes('\n')}>{link.label}</TileLabel>
						</Tile>
					)
				})}
			</TileRow>
		</>
	)
}

export default FrequentlyAccessed
